import Vue from 'vue'
import Router from 'vue-router'
import store from '../_vuex'
import { getAllAppMenus } from '../api/manage'
import { filterPath } from '../utils/constant'
import { filterAsyncRouter } from '../utils/appUtil'
import cookieUtil from '../utils/cookieUtil'

Vue.use(Router)

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err)
}

const router = new Router({
    routes: [{
        path: '/',
        redirect: '/login'
    },
    {
        name: 'login',
        path: '/login',
        component: () => import('../pages/login'),
        meta: {
            title: '登录'
        }
    },
    {
        name: 'toLogin',
        path: '/toLogin',
        component: () => import('../pages/toLogin'),
        meta: {
            title: '登录跳转'
        }
    },
    {
        name: 'env',
        path: '/env',
        component: () => import('../pages/chuBoard/env.vue'),
        meta: {
            title: '环境监测'
        }
    },
    {
        name: 'installPersonList',
        path: '/installPersonList',
        component: () => import('../installPersonList.vue'),
        meta: {
            title: '设备录入列表'
        }
    },
    {
        name: 'elevator',
        path: '/elevator',
        component: () => import('../pages/chuBoard/elevator.vue'),
        meta: {
            title: '施工升降机'
        }
    },
    {
        name: 'realName',
        path: '/realName',
        component: () => import('../pages/chuBoard/realName.vue'),
        meta: {
            title: '实名制'
        }
    },
    {
        name: 'tower',
        path: '/tower',
        component: () => import('../pages/chuBoard/tower.vue'),
        meta: {
            title: '塔式起重机'
        }
    },
    {
        name: 'video',
        path: '/video',
        component: () => import('../pages/chuBoard/video.vue'),
        meta: {
            title: '视频监控'
        }
    },
    {
        name: 'mstBoard',
        path: '/mstBoard',
        component: () => import('../pages/chuBoard/mstBoard.vue'),
        meta: {
            title: '项目看板'
        }
    },
    {
        name: 'keyPostCheck',
        path: '/keyPostCheck',
        component: () => import('../pages/chuBoard/keyPostCheck.vue'),
        meta: {
            title: '关键岗位人员考勤记录'
        }
    },
    {
        name: 'allPersonInfo',
        path: '/allPersonInfo',
        component: () => import('../pages/chuBoard/allPersonInfo.vue'),
        meta: {
            title: '人员列表'
        }
    },
    {
        name: 'envHistory',
        path: '/envHistory',
        component: () => import('../pages/chuBoard/envHistory.vue'),
        meta: {
            title: '环境监测历史'
        }
    },
    {
        name: 'personCheckInfo',
        path: '/personCheckInfo',
        component: () => import('../pages/chuBoard/personCheckInfo.vue'),
        meta: {
            title: '考勤记录'
        }
    },
    {
        name: 'moreDetail',
        path: '/moreDetail',
        component: () => import('../pages/apps/deepPit/moreDetail.vue'),
        meta: {
            title: '测点历史记录'
        }
    },
    {
        name: 'managePage_demo',
        path: '/managePage_demo',
        component: () => import('../pages/manage/proInfoItem_demo/index'),
        meta: {
            title: '面板demo'
        }
    },
    {
        name: 'jump',
        path: '/jump',
        component: () => import('../pages/login/jump'),
        meta: {
            title: '登录'
        }
    },

    {
        name: 'visitor',
        path: '/visitor',
        component: () => import('../pages/visit/plan')
    }, {
        name: 'checkin',
        path: '/checkin',
        component: () => import('../pages/manage/homepage/checkin'),
        meta: {
            title: '我的考勤'
        }
    }, {
        name: 'projectlist',
        path: '/projectlist',
        component: () => import('../pages/apps/projectList'),
        meta: {
            title: '项目列表'
        }
    }, {
        name: 'personlist',
        path: '/personlist',
        component: () => import('../pages/apps/projectPerson/PersonList'),
        meta: {
            title: '人员列表'
        }
    }, {
        name: 'personinfo',
        path: '/personinfo',
        component: () => import('../pages/apps/projectPerson/PersonInfo'),
        meta: {
            title: '人员详情'
        }
    }, {
        name: 'inspectioninfo',
        path: '/inspectioninfo',
        component: () => import('../pages/apps/inspectionWay/info'),
        meta: {
            title: '移动路线巡检详情'
        }
    },
    {
        name: 'check',
        path: '/check',
        component: () => import('../pages/apps/inspectionWay/check'),
        meta: {
            title: '开始巡检'
        }
    },
    {
        name: 'checkDetils',
        path: '/checkDetils',
        component: () => import('../pages/apps/inspectionWay/checkDetils'),
        meta: {
            title: '路线详情'
        }
    },
    {
        name: 'checkList',
        path: '/checkData',
        component: () => import('../pages/apps/enterPlan/checkData'),
        meta: {
            title: '提交巡检报告'
        }
    },
    {
        name: 'inspectionsave',
        path: '/inspectionsave',
        component: () => import('../pages/apps/inspectionWay/save'),
        meta: {
            title: '巡检路线结果添加'
        }
    },
    {
        name: 'inspectionsavePoint',
        path: '/inspectionsavePoint',
        component: () => import('../pages/apps/inspectionWay/savePoint'),
        meta: {
            title: '巡检点结果添加'
        }
    },
    {
        name: 'course',
        path: '/courselearn',
        component: () => import('../pages/apps/course-learn'),
        meta: {
            title: '安全培训'
        }
    },
    {
        name: 'checksData',
        path: '/checksData',
        component: () => import('../pages/apps/questios/components/checksData'),
        meta: {
            title: '问题整改'
        }
    },
    {
        name: 'courseinfo',
        path: '/courseinfo',
        component: () => import('../pages/apps/course-learn/Courseinfo'),
        meta: {
            title: '课程详情'
        }
    }, {
        name: 'courseplay',
        path: '/courseplay',
        component: () => import('../pages/apps/course-learn/Courseplay'),
        meta: {
            title: '课程学习'
        }
    }, {
        name: 'identify',
        path: '/identify',
        component: () => import('../pages/apps/course-learn/face/identify'),
        meta: {
            title: '人脸认证'
        }
    }, {
        name: 'beginExam',
        path: '/beginExam',
        component: () => import('../pages/apps/exam-online/BeginExam'),
        meta: {
            title: '当前测试'
        }
    }, {
        name: 'noticeInfo',
        path: '/noticeInfo',
        component: () => import('../pages/apps/notice/noticeinfo'),
        meta: {
            title: '通知管理'
        }
    }, {
        name: 'afterExam',
        path: '/afterExam',
        component: () => import('../pages/apps/exam-online/AfterExam'),
        meta: {
            title: '历史测试'
        }
    }, {
        name: 'courseManagementInfo',
        path: '/courseManagementInfo',
        component: () => import('../pages/apps/courseManagement/courseManagementInfo'),
        meta: {
            title: '课程详情'
        }
    }, {
        name: 'dangerCheckSave',
        path: '/danger-check/save',
        component: () => import('../pages/apps/danger-check/save'),
        meta: {
            title: '安全巡检添加'
        }
    }, {
        name: 'dangerCheckInfo',
        path: '/danger-check/info',
        component: () => import('../pages/apps/danger-check/info'),
        meta: {
            title: '安全巡检详情'
        }
    }, {
        name: 'actualInfo',
        path: '/actual/actualInfo',
        component: () => import('../pages/apps/actual/actualInfo'),
        meta: {
            title: '检查内容列表'
        }
    }, {
        name: 'actualSave',
        path: '/actual/save',
        component: () => import('../pages/apps/actual/save'),
        meta: {
            title: '新增测量表单'
        }
    }, {
        name: 'actualInfoSave',
        path: '/actual/actualInfoSave',
        component: () => import('../pages/apps/actual/actualInfoSave'),
        meta: {
            title: '添加测量数据'
        }
    }, {
        name: 'anyPhotoSave',
        path: '/anyPhoto/save',
        component: () => import('../pages/apps/anyPhoto/save'),
        meta: {
            title: '随手拍添加'
        }
    }, {
        name: 'anyPhotoInfo',
        path: '/anyPhoto/info',
        component: () => import('../pages/apps/anyPhoto/info'),
        meta: {
            title: '随手拍详情'
        }
    }, {
        name: 'reportBillSave',
        path: '/reportBill/save',
        component: () => import('../pages/apps/reportBill/save'),
        meta: {
            title: '检查单添加'
        }
    }, {
        name: 'reportBillInfo',
        path: '/reportBill/info',
        component: () => import('../pages/apps/reportBill/info'),
        meta: {
            title: '检查单详情'
        }
    },
    {
        name: 'addLot',
        path: '/lotCheckout/addLot',
        component: () => import('../pages/apps/lotCheckout/addLot'),
        meta: {
            title: '添加检验批'
        }
    },
    {
        name: 'viewLot',
        path: '/lotCheckout/viewLot',
        component: () => import('../pages/apps/lotCheckout/viewLot'),
        meta: {
            title: '查看检验批'
        }
    },
    {
        name: 'limbSave',
        path: '/limb/save',
        component: () => import('../pages/apps/limb/save'),
        meta: {
            title: '临边防护详情'
        }
    },
    {
        name: 'safeDeatil',
        path: '/pages/apps/safeDeatil',
        component: () => import('../pages/apps/safeLog/safeDeatil'),
        meta: {
            title: '安全日志详情'
        }
    },
    {
        name: 'safeAdd',
        path: '/pages/apps/safeAdd',
        component: () => import('../pages/apps/safeLog/safeAdd'),
        meta: {
            title: '添加安全日志'
        }
    },
    {
        name: 'limbAdd',
        path: '/limb/add',
        component: () => import('../pages/apps/limb/add'),
        meta: {
            title: '添加检查记录'
        }
    },
     {
        name: 'progressPlanInfo',
        path: '/progressPlan/info',
        component: () => import('../pages/apps/progressPlan/info'),
        meta: {
            title: '进度详情'
        }
    }, {
        name: 'disinfectSave',
        path: '/disinfect/save',
        component: () => import('../pages/apps/disinfect-record/save'),
        meta: {
            title: '消杀添加'
        }
    }, {
        name: 'disinfectInfo',
        path: '/disinfect/info',
        component: () => import('../pages/apps/disinfect-record/info'),
        meta: {
            title: '消杀详情'
        }
    },
    {
        name: 'reportBill',
        path: '/reportBill',
        component: () => import('../pages/apps/reportBill'),
        meta: { title: '随手拍', icon: 'example' },
        redirect: '/reportBill/home',
        children: [
            {
                name: 'list',
                path: 'list',
                showMenu: true,
                component: () => import('../pages/apps/reportBill/list'),
                meta: { title: '检查记录', icon: 'example' }
            },
            {
                path: 'home',
                showMenu: true,
                component: () => import('../pages/apps/reportBill/home'),
                name: '主页',
                meta: { title: '主页', noCache: true, icon: 'example' }
            },
            {
                path: 'save',
                showMenu: true,
                component: () => import('../pages/apps/reportBill/save'),
                name: '我的',
                meta: { title: '检查单添加', noCache: true, icon: 'example' }
            }
        ]
    },
    {
        name: 'apps',
        path: '/app',
        component: () => import('../pages/apps'),
        children: [
            {
                name: 'jijianContent',
                path: '/app/jijian/content',
                component: () => import('../pages/apps/jijian/content'),
                meta: {
                    title: '纪检安全'
                }
            },
            {
                name: 'jijianAnswer',
                path: '/app/jijian/answer',
                component: () => import('../pages/apps/jijian/answer'),
                meta: {
                    title: '纪检安全'
                }
            },
            {
                name: 'jijianContentDetail',
                path: '/app/jijian/content/detail',
                component: () => import('../pages/apps/jijian/detail'),
                params: { item: null },
                meta: {
                    title: '纪检安全'
                }
            },
            {
                name: 'dustControl',
                path: '/app/environment/dustControl',
                component: () => import('../pages/apps/environment/dustControl'),
                meta: {
                    title: '控制面板'
                }
            }
        ]
    },
    {
        name: 'personInfo',
        path: '/app/personInfo',
        component: () => import('../pages/apps/personInfo/info'),
        meta: {
            title: '人员信息'
        }
    },
    {
        name: 'leaderCheckSave',
        path: '/leader-check/save',
        component: () => import('../pages/apps/leader-check/save'),
        meta: {
            title: '督导检查添加'
        }
    }, {
        name: 'leaderCheckInfo',
        path: '/leader-check/info',
        component: () => import('../pages/apps/leader-check/info'),
        meta: {
            title: '督导检查详情'
        }
    }, {
        name: 'updatePassword',
        path: '/updatePassword',
        component: () => import('../pages/manage/homepage/updatePassword/index'),
        meta: {
            title: '修改密码'
        }
    },
    {
        name: 'areaCheckInfo',
        path: '/area-check/info',
        component: () => import('../pages/apps/areaCheck/info'),
        meta: {
            title: '巡检详情'
        }
    }, {
        name: 'areaCheckSave',
        path: '/area-check/save',
        component: () => import('../pages/apps/areaCheck/form'),
        meta: {
            title: '记录巡检结果'
        }
    },
    {
        name: 'monitorPlay',
        path: '/monitorPlay',
        component: () => import('../pages/apps/monitor/Play'),
        meta: {
            title: '播放监控'
        }
    },
    {
        name: 'proInfoItem',
        path: '/proInfoItem',
        component: () => import('@/pages/manage/proInfoItem'),
        meta: {
            title: '项目详情'
        }
    },
    {
        name: 'inspectionSheet',
        path: '/inspectionSheet',
        component: () => import('@/pages/apps/selfChecking/inspectionSheet'),
        meta: {
            title: "工序检查单"
        }
    },
    {
        name: 'hiddenDangerInfo',
        path: '/hiddenDangerInfo',
        component: () => import('@/pages/apps/hiddenDanger/info'),
        meta: {
            title: "隐患排查详情"
        }
    },
    {
        name: 'hiddenDangerSave',
        path: '/hiddenDangerSave',
        component: () => import('@/pages/apps/hiddenDanger/save'),
        meta: {
            title: "新增隐患排查"
        }
    },
    {
        name: 'hiddenDangerSubKeyList',
        path: '/hiddenDangerSubKeyList',
        component: () => import('@/pages/apps/hiddenDanger/subKeyList'),
        meta: {
            title: "选择检查分项"
        }
    },
    {
        name: 'safetyScoreInfo',
        path: '/safetyScoreInfo',
        component: () => import('@/pages/apps/safetyScore/info'),
        meta: {
            title: "评分详情"
        }
    },
    {
        name: 'safetyScoreSave',
        path: '/safetyScoreSave',
        component: () => import('@/pages/apps/safetyScore/save'),
        meta: {
            title: "新增安全评分"
        }
    },
    {
        name: 'safetyScoreCheckItem',
        path: '/safetyScoreCheckItem',
        component: () => import('@/pages/apps/safetyScore/checkItem'),
        meta: {
            title: "检查项目"
        }
    },
    {
        name: 'safetyScoreDeduct',
        path: '/safetyScoreDeduct',
        component: () => import('@/pages/apps/safetyScore/deductList'),
        meta: {
            title: "扣分标准"
        }
    },
    {
        name: 'safetyScoreDeductInfo',
        path: '/safetyScoreDeductInfo',
        component: () => import('@/pages/apps/safetyScore/deductInfo'),
        meta: {
            title: "扣分标准"
        }
    },
    {
        name: 'selfInspectionDetails',
        path: '/selfInspectionDetails',
        component: () => import('@/pages/apps/selfChecking/selfInspectionDetails'),
        meta: {
            title: "检查单详情"
        }
    },

    {
        name: 'managePage',
        path: '/manage',
        component: () => import('../pages/manage'),
        redirect: '/manage/work-station',
        meta: {
            title: '管理页面'
        },
        children: [
            {
                name: 'workStation',
                path: '/manage/work-station',
                component: () => import('../pages/manage/work-station'),
                meta: {
                    title: '工作台'
                }
            },
            {
                name: 'manageProject',
                path: '/manage/project',
                component: () => import('../pages/manage/project'),
                meta: {
                    title: '项目'
                }
            },
            {
                name: 'manageHomePage',
                path: '/manage/homepage',
                component: () => import('../pages/manage/homepage'),
                meta: {
                    title: '我的信息'
                }
            }
        ]
    },
    {
        name: 'proInfo',
        path: '/proInfo',
        component: () => import('../pages/chuBoard/newCommon/proInfo.vue'),
        meta: {
            title: '工程基本信息'
        },
    },
    {
        name: 'userCheckInfo',
        path: '/userCheckInfo',
        component: () => import('@/pages/chuBoard/newCommon/personCheckInfo.vue'),
        meta: {
            title: '人员信息'
        },
    },
    {
        name: 'cameraInfo',
        path: '/cameraInfo',
        component: () => import('@/pages/chuBoard/newCommon/cameraInfo.vue'),
        meta: {
            title: '视频监控'
        },
    },
    {
        name: 'envInfo',
        path: '/envInfo',
        component: () => import('@/pages/chuBoard/newCommon/envInfo.vue'),
        meta: {
            title: '环境监测'
        },
    },
    {
        name: 'towerInfo',
        path: '/towerInfo',
        component: () => import('@/pages/chuBoard/newCommon/towerInfo.vue'),
        meta: {
            title: '塔机监测'
        },
    },
    {
        name: 'elevatorInfo',
        path: '/elevatorInfo',
        component: () => import('@/pages/chuBoard/newCommon/elevatorInfo.vue'),
        meta: {
            title: '升降机监测'
        },
    },
    {
        name: 'wokerINfo',
        path: '/workerInfo/:id',
        component: () => import('@/pages/apps/epidemic/workerInfo.vue'),
        meta: {
            title: '工人详情记录'
        }
    },
    {
        name: 'partyClassInfo',
        path: '/partyClassInfo',
        component: () => import('@/pages/apps/partyClass/info.vue'),
        meta: {
            title: '党课详情'
        }
    },
    {
        name: 'riskInfo',
        path: '/riskCheck/info',
        component: () => import('@/pages/apps/riskCheck/info.vue'),
        meta: {
            title: '风险详情'
        }
    },
    {
        name: 'riskSave',
        path: '/riskCheck/save',
        component: () => import('@/pages/apps/riskCheck/save.vue'),
        meta: {
            title: '新增风险检查'
        }
    },
    {
        name: 'tdwarnList',
        path: '/tdwatch/warnList',
        component: () => import('@/pages/apps/tdwatch/warnList.vue'),
        meta: {
            title: '塔吊实时告警信息'
        }
    },
    {
        name: 'elewarnList',
        path: '/elevator/warnList',
        component: () => import('@/pages/apps/elevator/warnList.vue'),
        meta: {
            title: '升降机实时告警信息'
        }
    },
    {
        name: 'viewBim',
        path: '/viewBim',
        component: () => import('@/pages/apps/BIM/viewBim.vue'),
        meta: {
            title: 'BIM模型详情'
        }
    },
    {
        name: 'bimProgress',
        path: '/bimProgress',
        component: () => import('@/pages/apps/BIM/bimProgress'),
        meta: {
            title: 'BIM进度模拟'
        }
    },
    {
        name: 'shiftCheckSave',
        path: '/shiftCheck/save',
        component: () => import('../pages/apps/shiftCheck/save.vue'),
        meta: {
            title: '带班检查添加'
        }
    }, {
        name: 'shiftCheckInfo',
        path: '/shiftCheck/info',
        component: () => import('../pages/apps/shiftCheck/info.vue'),
        meta: {
            title: '带班检查详情'
        }
    },
    ]
})

store.dispatch('setLogoAction')

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    // 白名单
    if (filterPath.indexOf(to.path) !== -1) {
        next()
    } else {
        if (!cookieUtil.get('token')) {
            next('/login')
        } else {
            if (!store.getters.getSelectProject) {
                try {
                    store.dispatch('newActionProjectList').then(res => {
                        next()
                    })
                } catch (err) {
                    console.log(err)
                }

            } else {
                next()
            }
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/_router/index.js